export enum ButtonClass {
    DEFAULT = 'default',
    PRIMARY = 'primary',
}